import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import usePageMeta from "../hooks/usePageMeta";

export default function AuthPage() {
  usePageMeta("Sign In | Tiff. Wellness Co.", "Sign in or create your tiff. wellness co. account to manage orders and subscriptions.", { robots: "noindex,nofollow" });
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "", marketing_opt_in: false });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = mode === "login" ? await login(form.email, form.password) : await register(form);
      toast.success(`Welcome${u.name ? ", " + u.name : ""}!`);
      const next = params.get("next");
      navigate(next || (u.role === "admin" ? "/admin" : u.role === "partner" ? "/partner" : "/account"));
    } catch (err) { const m = errMsg(err); setError(m); toast.error(m); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <h1 className="text-4xl mb-6">{mode === "login" ? "Sign in" : "Create account"}</h1>
      <form onSubmit={submit} className="card-paper p-6 space-y-4">
        {mode === "register" && (
          <div><label htmlFor="name" className="text-xs font-medium block mb-1">Name</label>
            <input id="name" data-testid="auth-name-input" className="input-line" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
        )}
        <div><label htmlFor="email" className="text-xs font-medium block mb-1">Email</label>
          <input id="email" data-testid="auth-email-input" type="email" required className="input-line" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
        <div><label htmlFor="password" className="text-xs font-medium block mb-1">Password {mode === "register" && <span className="text-[#171715]/50">(min 8 characters)</span>}</label>
          <input id="password" data-testid="auth-password-input" type="password" required minLength={8} className="input-line" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
        {mode === "register" && (
          <label className="flex items-start gap-2 text-xs text-[#171715]/75">
            <input data-testid="auth-marketing-consent-checkbox" type="checkbox" className="mt-0.5 h-5 w-5" checked={form.marketing_opt_in} onChange={(e) => setForm({ ...form, marketing_opt_in: e.target.checked })} />
            <span>Email me about new pickups and juices (optional, never prechecked).</span>
          </label>
        )}
        {error && <p role="alert" data-testid="auth-error-message" className="text-sm text-[#9c3b2a]">{error}</p>}
        <button data-testid="auth-submit-button" className="btn-ink w-full" disabled={busy}>{busy ? "…" : mode === "login" ? "Sign in" : "Create account"}</button>
      </form>
      <button data-testid="auth-toggle-mode-button" className="underline text-sm mt-4 min-h-[44px]" onClick={() => setMode(mode === "login" ? "register" : "login")}>
        {mode === "login" ? "New here? Create an account" : "Have an account? Sign in"}
      </button>
    </div>
  );
}
